// src/config/constants.js

export const CONTRACTS = {
  SUSHISWAP_V2_ROUTER: '0xd9e1cE17f2641f24aE83637ab66a2cca9C378B9F',
  SUSHISWAP_V2_FACTORY: '0xC0AEe478e3658e2610c5F7A4A2E1777cE9e4f2Ac',
  WETH: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
};

export const COMMON_TOKENS = [
  // Эфир остаётся "isNative: true"
  {
    symbol: 'ETH',
    name: 'Ethereum',
    icon: '⟠',
    isNative: true,
    decimals: 18,
  },
  {
    symbol: 'WBTC',
    name: 'Wrapped Bitcoin',
    icon: '₿',
    address: '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599',
    decimals: 8,
    isNative: false,
  },
  {
    symbol: 'USDT',
    name: 'Tether USD',
    icon: '💲',
    address: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    decimals: 6,
    isNative: false,
  },
  {
    symbol: 'USDC',
    name: 'USD Coin',
    icon: '$',
    address: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
    decimals: 6,
    isNative: false,
  },
  {
    symbol: 'DAI',
    name: 'Dai Stablecoin',
    icon: '🦊',
    address: '0x6B175474E89094C44Da98b954EedeAC495271d0F',
    decimals: 18,
    isNative: false,
  },
  {
    symbol: 'SUSHI',
    name: 'SushiSwap Token',
    icon: '🍣',
    address: '0x6b3595068778dd592e39a122f4f5a5cf09c90fe2',
    decimals: 18,
    isNative: false,
  },
  {
    symbol: 'UNI',
    name: 'Uniswap',
    icon: '🦄',
    address: '0x1f9840a85d5aF5bf1D1762F925BDADdc4201F984',
    decimals: 18,
    isNative: false,
  },
  {
    symbol: 'LINK',
    name: 'Chainlink',
    icon: '🔗',
    address: '0x514910771AF9Ca656af840dff83E8264EcF986CA',
    decimals: 18,
    isNative: false,
  },
  {
    symbol: 'AAVE',
    name: 'Aave',
    icon: '👻',
    address: '0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9',
    decimals: 18,
    isNative: false,
  },
  {
    symbol: 'YFI',
    name: 'Yearn.Finance',
    icon: '🐮',
    address: '0x0bc529c00C6401aEF6D220BE8C6Ea1667F6Ad93e',
    decimals: 18,
    isNative: false,
  },
  {
    symbol: 'COMP',
    name: 'Compound',
    icon: '💚',
    address: '0xc00e94Cb662C3520282E6f5717214004A7f26888',
    decimals: 18,
    isNative: false,
  },
  {
    symbol: 'MKR',
    name: 'Maker',
    icon: '🏠',
    address: '0x9f8f72aA9304c8B593d555F12ef6589CC3A579A2',
    decimals: 18,
    isNative: false,
  },
  {
    symbol: 'SNX',
    name: 'Synthetix',
    icon: '👁‍🗨',
    address: '0xC011A72400E58ecD99Ee497CF89E3775d4bd732F',
    decimals: 18,
    isNative: false,
  },
  {
    symbol: 'BAL',
    name: 'Balancer',
    icon: '🎛',
    address: '0xba100000625a3754423978a60c9317c58a424e3D',
    decimals: 18,
    isNative: false,
  },
  {
    symbol: 'CRV',
    name: 'Curve DAO Token',
    icon: '⤵️',
    address: '0xD533a949740bb3306d119CC777fa900bA034cd52',
    decimals: 18,
    isNative: false,
  },
  {
    symbol: 'RENBTC',
    name: 'renBTC',
    icon: '🦇',
    address: '0xeb4c2781e4eba804ce9a9803c67d0893436bb27d',
    decimals: 8,
    isNative: false,
  },
  {
    symbol: '1INCH',
    name: '1inch',
    icon: '🦄',
    address: '0x111111111117dC0aa78b770fa6A738034120C302',
    decimals: 18,
    isNative: false,
  },
  {
    symbol: 'GRT',
    name: 'The Graph',
    icon: '🔎',
    address: '0xc944E90C64B2c07662A292be6244BDf05Cda44a7',
    decimals: 18,
    isNative: false,
  },
  {
    symbol: 'MATIC',
    name: 'Polygon (bridged)',
    icon: '🔶',
    address: '0x7d1afa7b718fb893db30a3abc0cfc608aacfebb0',
    decimals: 18,
    isNative: false,
  },
  {
    symbol: 'OMG',
    name: 'OMG Network',
    icon: '🛒',
    address: '0xd26114cd6EE289AccF82350c8d8487fedB8A0C07',
    decimals: 18,
    isNative: false,
  },
  {
    symbol: 'BAT',
    name: 'Basic Attention Token',
    icon: '🦁',
    address: '0x0D8775F648430679A709E98d2b0Cb6250d2887EF',
    decimals: 18,
    isNative: false,
  },
  {
    symbol: 'ZRX',
    name: '0x Protocol Token',
    icon: '0️⃣',
    address: '0xE41d2489571d322189246DaFA5ebDe1F4699F498',
    decimals: 18,
    isNative: false,
  },
  // ... Если хотите добавить ещё (CAKE, BNB и т.д.) — ищите их ERC-20 адреса и ликвидность на SushiSwap V2.
];
